// extracted by mini-css-extract-plugin
module.exports = {"content":"Address_content__2KxYz","itemForContent":"Address_itemForContent__27zFI"};